import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useDashboardContext } from './DashboardProvider';
import { useAuth } from './AuthProvider';

const ControlSocketContext = createContext();

const ControlSocketProvider = ({ children }) => {


  const { user } = useAuth();

  const {
    loading, fetchClusterComponentsTree, componentsTree, selectedCluster
  } = useDashboardContext();

  // const [computerId, setComputerId] = useState("");
  const [clusterId, setClusterId] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [userId, setUserId] = useState("");

  const [connected, setConnected] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);

  const [request, setRequest] = useState({});
  const [response, setResponse] = useState({});

  const [components, setComponents] = useState([]);

  const [connectionOptions, setConnectionOptions] = useState([]);

  const ws = useRef();

  const baseUrl = "wss://en954tmwha.execute-api.us-west-1.amazonaws.com/production/";

  useEffect(() => {
    // console.log(componentsTree);
    if (componentsTree?.blocks) {
      const options = [];
      componentsTree.blocks.map((block_info, index) => {
        // console.log(block_info);
        if (block_info.block_name != "" && block_info.computer_id.length > 0) {
          const option = {
            block_id: block_info.block_id,
            block_name: block_info.block_name,
            block_type: block_info.block_type,
            computer_id: block_info.computer_id[0],
          }
          options.push(option);
        }
      })
      setConnectionOptions(options);
      // setSelectedConnection(options[0].block_id);
      // console.log(options[0]);
    }
  }, [componentsTree])


  useEffect(() => {
    // console.log(response);
    if (response) {
      if (response.components && response.component == null && response.command == "ping") {
        const options = [];
        Object.keys(response.components).forEach((key) => {
          options.push(key);
        })
        setComponents(options);
      }
    }
  }, [response]);

  function clear() {
    setRequest({});
    setResponse({});
  }



  function connect(computerId) {
    console.log("Connecting...");
    setResponse({});

    // Open connection
    setWaiting(true);
    ws.current = new WebSocket(
      `${baseUrl}?access_token=${accessToken}&cluster_id=${clusterId}&user_id=${userId}&computer_id=${computerId}`
    );

    ws.current.onopen = () => {
      console.log("Connected");
      setWaiting(false);
      setConnected(prev => true);
      const testMessage = { command: "ping" };
      send(testMessage, true);
    };

    ws.current.onmessage = (event) => {
      const _response = JSON.parse(event.data);
      if (_response.payload) {
        // console.log(_response.payload)
        setResponse(_response.payload);
      }
      setRemainingTime(0);
      setWaiting(false);
    };

    ws.current.onclose = () => {
      console.log("Disconnected");
      setWaiting(false);
      setConnected(false);
    };
  }

  function disconnect() {
    console.log("Disconnecting...");
    setRemainingTime(0);
    setWaiting(false);

    if (ws.current != null) {
      ws.current.close();
    } else {
      setConnected(false);
    }
  }


  function send(message, forced = false) {
    if (ws.current) {
      if (forced || connected) {

        ws.current.send(JSON.stringify({
          "action": "publish",
          "message": message
        }));

        setRequest(message);
        setResponse({});
        setWaiting(true);
        setRemainingTime(10);
      }
    }
  }

  useEffect(() => {
    // console.log(user);
    if (user?.email) {
      setUserId(user.email);
    }
    if (user?.credentials?.AccessToken) {
      setAccessToken(user.credentials.AccessToken);
      // console.log(user.credentials.AccessToken);      
    }
  }, [user]);


  useEffect(() => {
    // console.log(user);
    if (selectedCluster?.cluster_id) {
      setClusterId(selectedCluster.cluster_id);
      fetchClusterComponentsTree();
    }
  }, [selectedCluster]);


  useEffect(() => {
    let timer;

    if (remainingTime !== null && remainingTime > 0) {
      timer = setInterval(() => {
        setRemainingTime((prev) => (prev !== null ? prev - 1 : null));
      }, 1000);
    } else if (remainingTime === 0) {
      // alert("Timer expired!");
    }

    return () => clearInterval(timer);
  }, [remainingTime]);


  return (
    <ControlSocketContext.Provider
      value={{
        connect,
        disconnect,
        send,
        request,
        response,
        connected,
        waiting,
        components,
        connectionOptions,
        clear,
      }}
    >
      {children}
    </ControlSocketContext.Provider>
  )
}

export const useControlSocketContext = () => useContext(ControlSocketContext);

export default ControlSocketProvider;